import React from 'react';

import { IconWrapper } from '../PriceComponent/PriceComponentStyles';
import { TooltipContainer } from 'commonStyles';
import TermsAndConditions from '../TermsAndConditions/TermsAndConditions';
import Tooltip from 'common/Tooltip/Tooltip';
import { showModal } from 'reduxStore/actions/miceActionDispatcher';
import { useDispatch } from 'react-redux';
import { MODAL_TYPE } from '../../../../config';

const InfoWrapper = ({ toOpenModal, isMobile, termsAndConditions, isTile }) => {
	const dispatch = useDispatch();

	const infoClick = () => {
		dispatch(showModal({
			modalType: MODAL_TYPE.T_AND_C,
			modalData: termsAndConditions
		}));
	};

	const tooltipWidth = !isMobile ? 360 : 250;

	return (
		toOpenModal ?
			<IconWrapper
				top_M='4'
				as='span'
				onClick={infoClick}>i
			</IconWrapper> :
			<TooltipContainer position='relative'>
				<IconWrapper
					as='span'>i
				</IconWrapper>
				<Tooltip
					posLeft='8px'
					posTop='30px'
					transform={isTile ? 'translateX(-51%)' : 'translateX(-91%)'}
					bg_color='#F4FAFF'
					color='#000'
					width={tooltipWidth + 'px'}
					top_arr
					left={isTile ? '50%' : (tooltipWidth - 30) + 'px'}
					zIndex='900'>
					<TermsAndConditions data={termsAndConditions} />
				</Tooltip>
			</TooltipContainer>);
};

export default InfoWrapper;
